<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%; font-size: 12px !important;"
      :headers="headers"
      hide-default-header
      :items="transactions"
      :pagination.sync="pagination"
      :hide-default-footer="true"
      ref="transactionSummaryList"
      dense
    >
      <template v-slot:header="{ props }">
        <th v-for="head in props.headers">
          <div v-if="head.text == 'ID'">    
            <v-text-field 
              @keyup.enter="search"
              style="font-size: 11px !important;" hide-details v-model="query.idQuery" label="Reference"></v-text-field>
          </div>
          <div v-else-if="head.text == 'Date'">
           <v-row class="flex-nowrap">
              <BookingDateInput
                @input="fromChanged"
                :content="query.after"
                label="From"
                :old="true"
              />
              <v-icon v-if="query.after != ''" :size="12" @click="query.after = ''" style="padding-top: 0px;">clear</v-icon>
              <BookingDateInput
                @input="toChanged"
                :content="query.before"
                label="To"
                :old="true"
              />
              <v-icon v-if="query.before != ''" :size="12" @click="query.before = ''" style="padding-top: 0px;">clear</v-icon>
            </v-row>
          </div>
          <div v-else-if="head.text == 'Driver'">
            <v-text-field 
              @keyup.enter="search"
              style="font-size: 11px !important;" hide-details v-model="query.driverQuery" label="Driver"></v-text-field> 
          </div>
          <div v-else-if="head.text == 'Search'">
            <v-btn color="blue" x-small class="text-none" @click="search" text>Search</v-btn>
          </div>
          <div v-else>
            {{ head.text }}
          </div>
        </th>
      </template>
      <template v-slot:item="props">
        <tr>
          <td style="width:5%;">
            <div>
              <span>
                 {{ props.item.invoice_payment.id }}
                <br />
                <p>{{props.item.invoice_payment.token}}</p>
              </span>
            </div>
            <v-icon v-if="props.item.invoice_payment.chargeUuid != null" color="green" small :title="props.item.invoice_payment.chargeUuid">
              mdi-credit-card-check-outline
            </v-icon>
          </td>
          <td style="width:3%;">{{ props.item.invoice_payment.paidTimeOld.split(" ")[0] }}</td>
          <td style="width:3%;">{{ props.item.invoice_payment.paidTimeOld.split(" ")[1] }}</td>
          <td style="width:25%;">{{ invoiceIds(props.item.invoice_payment) }}</td>
          <td style="width:10%">
            <p>
              <b>{{props.item.invoice_payment.driver.callsign}}</b>
              {{ props.item.invoice_payment.driver.name }}
            </p>
          </td> 
          <td style="width:1%;">{{ getDriverTotal(props.item.invoice_payment.invoiceTotalSummaries, 'cash') }}</td>
          <td style="width:1%;">{{ getDriverTotal(props.item.invoice_payment.invoiceTotalSummaries, 'card') }}</td>
          <td style="width:1%;">{{ getDriverTotal(props.item.invoice_payment.invoiceTotalSummaries, 'account') }}</td>
          <td style="width:1%;">{{ getDriverTotal(props.item.invoice_payment.invoiceTotalSummaries, 'serviceFee') }}</td>
          <td style="width:1%;">{{ getDriverTotal(props.item.invoice_payment.invoiceTotalSummaries, 'extras') }}</td>
          <td style="width:1%;">{{ getDriverTotal(props.item.invoice_payment.invoiceTotalSummaries, 'payable') }}</td>
          <td style="width:1%; text-transform: capitalize;"></td>
        </tr>
      </template>
    </v-data-table>
   
  </div>
</template>

<script>
import { BookingForm } from "@/components/util/BookingForm.js";

import BookingDateInput from "@/components/widget/input/BookingDateInputSmall.vue";

import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "transaction_summary_list",
  components: {
    BookingDateInput
  },
  props: {
    transactions: Array,
    paginationProp: Object,
    rideTypes: Array,
    query: Object
  },
  mounted: async function() {
    if (this.$route.query.bookingID) {
      this.goToBooking(this.$route.query.bookingID);
      this.$route.query.bookingID = null;
    }
  },
  data: function() {
    return {
      dialog: Object,
      pagination: this.paginationProp,
      currentBookingID: -1,
      viewBookingDialog: false,
      loadingEditBooking: false,
      bookingForm: null,
      headers: [
         {
          text: "ID",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "pickup_date"
        },  
        {
          text: "Time",
          align: "left",
          sortable: false,
          value: "pickup_time"
        },
        {
          text: "Invoice IDs",
          align: "left",
          sortable: false,
          value: "invoice_ids"
        },
        {
          text: "Driver",
          align: "left",
          sortable: false,
          value: "driver"
        },
        {
          text: "Cash",
          align: "left",
          sortable: false,
          value: "£"
        },{
          text: "Card",
          align: "left",
          sortable: false,
          value: "£"
        },{
          text: "Account",
          align: "left",
          sortable: false,
          value: "£"
        },
        {
          text: "Commission",
          align: "left",
          sortable: false,
          value: "£"
        },   
        {
          text: "Extras",
          align: "left",
          sortable: false,
          value: "£"
        },
        {
          text: "Amount Paid",
          align: "left",
          sortable: false,
          value: "£"
        },
        {
          text: "Search",
          align: "left",
          sortable: false,
          value: "£"
        },
      ],
    };
  },
  methods: {
    getDriverTotal: function (invoices, type) {
      let total = 0;

      invoices.forEach(function (invoice) {
        total += invoice[type];
      });

      if (total == 0) {
        return "—";
      } else {
        return (total / 100).toFixed(2);
      }
    },
    invoiceIds: function(ip) {

      console.log(ip);

      var ids = "";

      for (var i = 0; i < ip.invoiceTotalSummaries.length; i++) {
        ids += ip.invoiceTotalSummaries[i].id + ", "
      }

      return ids;
    },
    fromChanged: function(d) {
      this.query.after = d;
    },
    toChanged: function(d) {
      this.query.before = d;
    },
    search() {
      this.$emit("search")
    },
    goToDriver: function(id) {
      window.open(`/driver/view/${id}`, "_blank");
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 4px !important;
}

thead th:not(:first-child) {
  padding: 0 8px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 22px;
  display: -webkit-flex;
  display: flex;
  align-items: center;
}

.v-data-table td {
  font-size: 11px !important;
  height: 19px;
}

.v-data-table th {
  font-size: 11px !important;
  height: 19px;
}

.circle {
  width: 16px;
  height: 16px;
  line-height: 15px;
  border-radius: 50%;
  background: #FFBB96;
  text-align: center;
}

td {
  line-height: 1.1;
}

.v-data-table td, .v-data-table th {
    padding: 0 2px !important;
        padding-top: 0px;
        padding-bottom: 0px;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
}

</style>
